import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService, Core2Config} from '../../shared';
import {ReviewRatingConfigContainerModel} from '../../../../../../models';

@Injectable({providedIn: 'root'})

export class ReviewRatingConfigService extends BaseApiTemplateService<ReviewRatingConfigContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/fi-item/review-rating-configs';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/fi-item/review-rating-configs';
    this.httpClient = http;
  }
}
